import useSWRImmutable from 'swr/immutable'
import { endpoints, request } from '#services'

/**
 * @typedef {Object} UseSearchAppearanceData
 * @property {string|undefined} description - Meta description.
 * @property {string|undefined} title - Meta title.
 */

/**
 * @typedef {Object} UseSearchAppearanceResult
 * @property {UseSearchAppearanceData} data
 * @property {any} isError
 * @property {boolean} isLoading
 * @property {function} mutate
 * @property {boolean} isValidating
 */

/**
 * React hook to fetch the search appearance (title and description) of a post or page from the WordPress REST API.
 * @param {object} params - Parameters for fetching search appearance.
 * @param {number} params.id - The post or page ID.
 * @param {string} params.type - The type: 'post' or 'page'.
 * @returns {UseSearchAppearanceResult}
 */
export const useSearchAppearance = ({ id, type }) => {
  const description = useSWRImmutable(
    id ? endpoints.searchAppearanceDescription.get({ id, type }) : null,
    request,
  )

  const title = useSWRImmutable(
    id ? endpoints.searchAppearanceTitle.get({ id, type }) : null,
    request,
  )
  return {
    data: {
      description: description.data?.data?.data?.description,
      title: title.data?.data?.data?.title,
    },
    isError: description.error || title.error,
    isLoading: description.isLoading || title.isLoading,
    mutate: () => {
      description.mutate()
      title.mutate()
    },
    isValidating: description.isValidating || title.isValidating,
  }
}
